import { BASE_URL } from "./apiCaller";
export default {
  // -----AUTH------//
  getUsers: BASE_URL + "user/allUsers",
  getUserData: BASE_URL + "user",
  signUp: BASE_URL + "user/signup",
  signIn: BASE_URL + "user/testLogin",
  blockUser: BASE_URL + "user/updateProfile",
  updateUser: BASE_URL + "user",
  getFeedbacks: BASE_URL + "feedback",
  getPrivacyPolicy: BASE_URL + "privacy",
  deletePrivacyPolicy: BASE_URL + "privacyPolicy",
  getAllFeedbacks: BASE_URL + "feedback",
  deleteFeedback: BASE_URL + "feedback",

  getAppStats: BASE_URL + "user/appStats",
  updatePrivacyPolicy: BASE_URL + "/privacy",

  getTermsOfUse: BASE_URL + "termsandcondition",
  addTermsOfUse: BASE_URL + "termsandcondition/create",
  updateTermsOfUse: BASE_URL + "termsandcondition",
  deleteTermsOfUse: BASE_URL + "termsandcondition",

  getYogas: BASE_URL + "getAllYogas",
  createFaceYoga: BASE_URL + "faceYoga",
  deleteFaceYoga: BASE_URL + "faceYoga",
  updateFaceYoga: BASE_URL + "faceYoga",

  getVideos: BASE_URL + "getAllVideos",
  createVideo: BASE_URL + "videos",
  deleteVideo: BASE_URL + "videos",
  updateVideo: BASE_URL + "videos",

  getAllBlogs: BASE_URL + "allBlogs",
  deleteBlog: BASE_URL + "blogs",
  updateBlog: BASE_URL + "blogs",
  createBlog: BASE_URL + "blogs",

  getTrainer: BASE_URL + "user/trainerProfile1",
  updateTrainer: BASE_URL + "user/updateTrainer",
  createTrainer: BASE_URL + "user/createTrainer",
  deleteTrainer: BASE_URL + "user/deleteTrainer",

  createCategory: BASE_URL + "category",
  getAllCategories: BASE_URL + "AllCateogories",
  updateCategory: BASE_URL + "category",
  deleteCategory: BASE_URL + "category",

  getSubCategories: BASE_URL + "AllSub",
  getSubCategoriesDropdown: BASE_URL + "category",

  deleteSubCategorie: BASE_URL + "category",
  updateSubCategorie: BASE_URL + "category",
  createSubCategorie: BASE_URL + "category",

  logOut: BASE_URL + "user/logout",
  upload: BASE_URL + "uploadImage",
  addFree: BASE_URL + "user/makeFree",

  // -------------Services-------------//
};
